import Vue from "vue";
import ComLoading from "./loading.vue";

const LoadingPlugin = {
  install(Vue) {
    // 创建一个Vue实例来挂载Loading组件
    const LoadingConstructor = Vue.extend(ComLoading);
    const loadingInstance = new LoadingConstructor();

    // 手动挂载实例到DOM
    loadingInstance.$mount();
    document.body.appendChild(loadingInstance.$el);

    // 定义全局方法
    Vue.prototype.$loading = {
      show(options = {}) {
        // 更新props
        Object.assign(loadingInstance, options);
        loadingInstance.showLoading = true;
      },
      hide() {
        loadingInstance.showLoading = false;
      }
    };
  }
};

export default LoadingPlugin;



// WEBPACK FOOTER //
// ./src/components/ComLoading/userLoading.js